import { createSlice } from '@reduxjs/toolkit'

import { fetchMenus, fetchCafeConfig, fetchCafeCashRegisters, fetchCafeGroups } from '../thunk/dashboardThunk'

const initialState = {
    // status
    isLoading: false,
    error: null,

    // data
    menus: [],
    filteredMenus: [],
    stalls: [],
    tables: [],
    cashRegisters: [],
    cafeGroups: [],
    updatedInventoryStatus: {},

    categories: [],
    selectedCategory: null,
    selectedProduct: null,
    searchValue: '',
    selectedGroupId: null,
}

export const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        setSelectedCategory: (state, action) => {
            state.selectedCategory = action.payload
        },
        setSelectedProduct: (state, action) => {
            state.selectedProduct = action.payload
        },
        setSearchValue: (state, action) => {
            const searchValue = action.payload

            const filteredMenus =
                searchValue ?
                    state.menus
                        .map(section => ({
                            category: section.category,
                            stallId: section.stallId,
                            items: section.items.filter(
                                item =>
                                    item.name.toLowerCase().includes(searchValue.toLowerCase()) ||
                                    item.variants.some(v => v.name.toLowerCase().includes(searchValue.toLowerCase()))
                            ),
                        }))
                        .filter(section => section.items.length > 0)
                :   state.menus

            state.searchValue = searchValue
            state.filteredMenus = filteredMenus
        },
        updateInventoryStatus: (state, action) => {
            const { ids, status } = action.payload

            // Convert to object format with id:status pairs
            ids.forEach(id => {
                state.updatedInventoryStatus[id] = status
            })
        },
        setSelectedGroupId: (state, action) => {
            state.selectedGroupId = action.payload
        },
    },
    extraReducers: builder => {
        builder
            /** fetchMenus */
            .addCase(fetchMenus.pending, state => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchMenus.fulfilled, (state, action) => {
                const { categories, filteredMenus } = action.payload

                state.isLoading = false
                state.menus = filteredMenus
                state.categories = categories
                state.filteredMenus = filteredMenus
                state.updatedInventoryStatus = {}
            })
            .addCase(fetchMenus.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.payload
            })

            /** fetchCafeConfig */
            .addCase(fetchCafeConfig.pending, state => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchCafeConfig.fulfilled, (state, action) => {
                const cafe = action.payload
                const { stalls, tables, cashRegisters } = cafe

                state.isLoading = false
                state.stalls = stalls
                state.selectedCategory = 'Drink Stall'
                state.categories = stalls.map(stall => stall.name)
                state.tables = tables.filter(table => table.name === 'Unknown')
                state.cashRegisters = cashRegisters
            })
            .addCase(fetchCafeConfig.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.payload
            })

            // fetchCafeCashRegisters
            .addCase(fetchCafeCashRegisters.pending, state => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchCafeCashRegisters.fulfilled, (state, action) => {
                state.isLoading = false
                state.cashRegisters = action.payload
            })
            .addCase(fetchCafeCashRegisters.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.payload
            })

            /** fetchCafeGroups */
            .addCase(fetchCafeGroups.pending, state => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchCafeGroups.fulfilled, (state, action) => {
                state.isLoading = false
                state.cafeGroups = action.payload
            })
            .addCase(fetchCafeGroups.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.payload
            })
    },
})

export const dashboardActions = {
    ...dashboardSlice.actions,
    fetchMenus,
    fetchCafeConfig,
    fetchCafeCashRegisters,
    fetchCafeGroups,
}

export default dashboardSlice.reducer
